import React from "react";
import NavLink from "./NavLink";

const Navigation = () => {
  return (
    <ul className="flex flex-col space-y-2 nav-bar lg:flex-row lg:space-y-0 lg:space-x-2 lg:flex-wrap lg:items-center">
      <NavLink to="/">Home</NavLink>
      {/* <NavLink to="/about">About</NavLink> */}
      {/* <NavLink to="/services">Services</NavLink> */}
      <NavLink to="/skills">Skills</NavLink>
      <NavLink to="/projects">Projects</NavLink>
      <NavLink to="/contact">Contact</NavLink>
    </ul>
  );
};

export default Navigation;
